<template>
  <section class="in-module bg-tex group">
    <div>
      <h3>Other Group</h3>
      <ul>
        <li><a href="https://rokuya-resort.com/" target="_blank" rel="nofollow"><img src="/images/common/logo_rokuya.webp" alt="網元の宿 ろくや"></a></li>
        <li><a href="https://www.nagisaplace-tateyama.com/" target="_blank" rel="nofollow"><img src="/images/common/logo_marche.webp" alt="海のマルシェたてやま"></a></li>
        <li><a href="https://www.nagisaplace-tateyama.com/" target="_blank" rel="nofollow"><img src="/images/common/logo_solennel.webp" alt="solennel"></a></li>
        <li><a href="https://www.nagisaplace-tateyama.com/restaurant" target="_blank" rel="nofollow"><img src="/images/common/logo_nagisa.webp" alt="なぎさ食堂"></a></li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.group{
  padding: 3.2rem module.side();
  position: relative;
  background: module.tone(module.$gray, -1);
  border-bottom: module.$gray 1px solid;
  div{
    max-width: 33rem;
    margin: 0 auto;
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 2rem;
    position: relative;
    z-index: 2;
    > *{
      align-self: center;
    }
  }
  ul{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 1.6rem;
    li{
      a{
        display: block;
      }
      img{
        width: 100%;
        border-radius: .4rem;
        box-shadow: 0 .4rem 1.2rem rgba(module.$black,.16);
      }
    }
  }
}
</style>